import { render, staticRenderFns } from "./SpotlightModuleWithHorizontalScroll.vue?vue&type=template&id=9374b174&scoped=true"
import script from "./SpotlightModuleWithHorizontalScroll.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpotlightModuleWithHorizontalScroll.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SpotlightModuleWithHorizontalScroll.vue?vue&type=style&index=0&id=9374b174&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9374b174",
  null
  
)

export default component.exports